import React from 'react';


/**
 * @class Forgot
 */
function Forgot() {
  return (
    <div>
      this is forgt
    </div>
  );
}

export default Forgot;


// WEBPACK FOOTER //
// ./src/routes/Profile/components/Forgot/index.js